import { createSelector } from 'reselect';
import PredesComplianceColumns from '../../containers/PredesComplianceColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.PREDES_COMPLIANCE.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_COMPLIANCE.isLoading;

export const getData =
  ReportDefinitions.PREDES_COMPLIANCE.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceColumns);
